import {
  ADD_TRANSFER_PATIENT_FAILURE,
  ADD_TRANSFER_PATIENT_REQUEST,
  ADD_TRANSFER_PATIENT_SUCCESS,
  DELETE_TRANSFER_PATIENT_FAILURE,
  DELETE_TRANSFER_PATIENT_REQUEST,
  DELETE_TRANSFER_PATIENT_SUCCESS,
  FETCH_LIST_TRANSFER_PATIENT_FAILURE,
  FETCH_LIST_TRANSFER_PATIENT_REQUEST,
  FETCH_LIST_TRANSFER_PATIENT_SUCCESS,
  FETCH_STAFF_TRANSFER_PATIENT_FAILURE,
  FETCH_STAFF_TRANSFER_PATIENT_REQUEST,
  FETCH_STAFF_TRANSFER_PATIENT_SUCCESS,
  FETCH_TRANSFER_PATIENT_FAILURE,
  FETCH_TRANSFER_PATIENT_REQUEST,
  FETCH_TRANSFER_PATIENT_SUCCESS,
  HISTORY_TRANSFER_PATIENT_FAILURE,
  HISTORY_TRANSFER_PATIENT_REQUEST,
  HISTORY_TRANSFER_PATIENT_SUCCESS,
  RESET_CURRENT_TRANSFER_PATIENT,
  UPDATE_TRANSFER_PATIENT_FAILURE,
  UPDATE_TRANSFER_PATIENT_REQUEST,
  UPDATE_TRANSFER_PATIENT_SUCCESS,
} from "./transferPatientType";

export const fetchTransferPatient = (pageNo) => ({
  type: FETCH_LIST_TRANSFER_PATIENT_REQUEST,
  payload: pageNo,
});

export const fetchTransferPatientSuccess = (transferPatient) => {
  return {
    type: FETCH_LIST_TRANSFER_PATIENT_SUCCESS,
    payload: { transferPatient },
  };
};

export const fetchTransferPatientFailure = (error) => ({
  type: FETCH_LIST_TRANSFER_PATIENT_FAILURE,
  payload: { error },
});

export const fetchHistoryTransferPatient = (id) => ({
  type: HISTORY_TRANSFER_PATIENT_REQUEST,
  payload: id,
});

export const fetchHistoryTransferPatientSuccess = (transferPatient) => ({
  type: HISTORY_TRANSFER_PATIENT_SUCCESS,
  payload: { transferPatient },
});

export const fetchHistoryTransferPatientFailure = (error) => ({
  type: HISTORY_TRANSFER_PATIENT_FAILURE,
  payload: { error },
});

// View single transfer patient
export const fetchTransferPatientMember = (transferPatientId ,pageNo) => {
  return {
    type: FETCH_TRANSFER_PATIENT_REQUEST,
    payload: { transferPatientId,pageNo },
  };
};

export const fetchTransferPatientMemberSuccess = (transferPatient) => ({
  type: FETCH_TRANSFER_PATIENT_SUCCESS,
  payload: { transferPatient },
});

export const fetchTransferPatientMemberFailure = (error) => ({
  type: FETCH_TRANSFER_PATIENT_FAILURE,
  payload: { error },
});

// Add transfer patient
export const addTransferPatient = (transferPatientData) => {
  return {
    type: ADD_TRANSFER_PATIENT_REQUEST,
    payload: transferPatientData,
  };
};

export const addTransferPatientSuccess = (transferPatient) => {
  return {
    type: ADD_TRANSFER_PATIENT_SUCCESS,
    payload: { transferPatient },
  };
};

export const addTransferPatientFailure = (error) => {
  return {
    type: ADD_TRANSFER_PATIENT_FAILURE,
    payload: { error },
  };
};

// Edit transfer patient
export const updateTransferPatient = (transferPatientId, transferPatientData) => {

  return {
    type: UPDATE_TRANSFER_PATIENT_REQUEST,
    payload: { transferPatientId, transferPatientData },
  };
};

export const updateTransferPatientSuccess = (transferPatient) => ({
  type: UPDATE_TRANSFER_PATIENT_SUCCESS,
  payload: { transferPatient },
});

export const updateTransferPatientFailure = (error) => ({
  type: UPDATE_TRANSFER_PATIENT_FAILURE,
  payload: { error },
});

// Delete transfer patient
export const deleteTransferPatient = (transferPatientId) => ({
  type: DELETE_TRANSFER_PATIENT_REQUEST,
  payload: { transferPatientId },
});

export const deleteTransferPatientSuccess = (transferPatientId) => ({
  type: DELETE_TRANSFER_PATIENT_SUCCESS,
  payload: { transferPatientId },
});

export const deleteTransferPatientFailure = (error) => ({
  type: DELETE_TRANSFER_PATIENT_FAILURE,
  payload: { error },
});

// Reset current transfer patient
export const resetCurrentTransferPatient = (pageNo) => ({
  type: RESET_CURRENT_TRANSFER_PATIENT,
  payload: pageNo,
});


// View single transfer patient
export const fetchStaffTransferPatientMember = (transferPatientId) => ({
  type: FETCH_STAFF_TRANSFER_PATIENT_REQUEST,
  payload: { transferPatientId },
});

export const fetchStaffTransferPatientMemberSuccess = (transferPatient) => ({
  type: FETCH_STAFF_TRANSFER_PATIENT_SUCCESS,
  payload: { transferPatient },
});

export const fetchStaffTransferPatientMemberFailure = (error) => ({
  type: FETCH_STAFF_TRANSFER_PATIENT_FAILURE,
  payload: { error },
});